<template>
    <div class="w-full">
        <h4 class="mb-3">Worker Channels</h4>

        <vx-card id="channelDiv"  class="vs-con-loading__container">

            <vs-table ref="table" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div>
                        <vs-button :disabled="selectedChannels.length === 0" style="float: left" icon-pack="feather" icon="icon-play" color="success" class="mt-6; mr-1" @click="startSelected"/>
                        <vs-button :disabled="selectedChannels.length === 0" style="float: left" icon-pack="feather" icon="icon-refresh-cw" color="warning" class="mt-6; mr-1" @click="restartSelected"/>
                        <vs-button :disabled="selectedChannels.length === 0" style="float: left" icon-pack="feather" icon="icon-square" color="danger" class="mt-6; mr-1" @click="disableSelected"/>
                    </div>

                    <div style="clear: both"></div>

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th key="ch1" v-if="!allSelected" style="width: 25px"><vs-checkbox style="float: left; width: 25px" icon="remove" v-model="someSelected"/></vs-th>
                    <vs-th key="ch2" v-else style="width: 25px"><vs-checkbox style="float: left; width: 25px" v-model="allSelected"/></vs-th>
                    <vs-th/>
                    <vs-th sort-key="worker_name" v-if="$store.state.windowWidth > 1000">Worker</vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="gpu_short" v-if="$store.state.windowWidth > 800">GPU</vs-th>
                    <vs-th sort-key="current_source_provider" v-if="$store.state.windowWidth > 800">Source provider</vs-th>
                    <vs-th sort-key="current_source_video_codec" v-if="$store.state.windowWidth > 800">Source video codec</vs-th>
                    <vs-th sort-key="current_source_dimensions" v-if="$store.state.windowWidth > 800">Source resolution</vs-th>
                    <vs-th sort-key="current_source_audio_codec" v-if="$store.state.windowWidth > 800">Source audio codec</vs-th>
                    <!--<vs-th sort-key="upstream_type" v-if="$store.state.windowWidth > 1800">Upstream type</vs-th>
                    <vs-th sort-key="in_template" v-if="$store.state.windowWidth > 1800">Input template</vs-th>
                    <vs-th sort-key="work_template" v-if="$store.state.windowWidth > 1800">Work template</vs-th>
                    <vs-th sort-key="out_template" v-if="$store.state.windowWidth > 1000">Output template</vs-th>-->
                    <vs-th sort-key="output_type">Output type</vs-th>
                    <vs-th sort-key="uptimeNum">Uptime</vs-th>
                    <vs-th style="width: 165px"/>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(tr, index) in data">

                        <vs-td style="width: 25px">
                            <vs-checkbox style="float: left; width: 25px" v-model="selectedChannels" :vs-value="data[index].id"/>
                        </vs-td>

                        <vs-td style="width: 60px">
                            <img v-if="data[index].image_id.length > 0" style="height: 25px" :src="'/api/management/v1/channel_logo/' + data[index].image_id" :alt="data[index].name">
                        </vs-td>

                        <vs-td :data="data[index].worker_name" v-if="$store.state.windowWidth > 1000">
                            {{ data[index].worker_name }}
                        </vs-td>

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].gpu_short" v-if="$store.state.windowWidth > 800">
                            {{ data[index].gpu_short }}
                        </vs-td>

                        <vs-td :data="data[index].current_source_provider" v-if="$store.state.windowWidth > 800">
                            {{ data[index].current_source_provider }}
                        </vs-td>

                        <vs-td :data="data[index].current_source_video_codec" v-if="$store.state.windowWidth > 800">
                            {{ data[index].current_source_video_codec }}
                        </vs-td>

                        <vs-td :data="data[index].current_source_dimensions" v-if="$store.state.windowWidth > 800">
                            {{ data[index].current_source_dimensions }}
                        </vs-td>

                        <vs-td :data="data[index].current_source_audio_codec" v-if="$store.state.windowWidth > 800">
                            {{ data[index].current_source_audio_codec }}
                        </vs-td>

                        <!--<vs-td :data="data[index].upstream_type" v-if="$store.state.windowWidth > 1800">
                            {{ data[index].upstream_type }}
                        </vs-td>

                        <vs-td :data="data[index].in_template" v-if="$store.state.windowWidth > 1800">
                            {{ data[index].in_template }}
                        </vs-td>

                        <vs-td :data="data[index].work_template" v-if="$store.state.windowWidth > 1800">
                            {{ data[index].work_template }}
                        </vs-td>

                        <vs-td :data="data[index].out_template" v-if="$store.state.windowWidth > 1000">
                            {{ data[index].out_template }}
                        </vs-td>-->

                        <vs-td :data="data[index].output_type">

                            <div v-if="data[index].status !== 0 && !data[index].disabled">
                                <vs-chip v-if="data[index].output_type === 1" color="#3498db">UDP</vs-chip>
                                <vs-chip v-else-if="data[index].output_type === 2" color="#2ecc71" style="cursor:pointer;" @click.native="getChannelLink(data[index].id)">HLS</vs-chip>
                                <vs-chip v-else-if="data[index].output_type === 3" color="#9b59b6" style="cursor:pointer;" @click.native="getChannelLink(data[index].id)">MPEGTS</vs-chip>
                                <vs-chip v-else color="warning">Unknown</vs-chip>
                            </div>

                        </vs-td>

                        <vs-td :data="data[index].uptime" style="width: 150px">
                            <p style="float: left" class="mt-3" v-if="!data[index].uptimeChip">
                                {{ data[index].uptime }}
                            </p>
                            <vs-chip :key="'uptimeChip-' + data[index].id + '-' + data[index].uptime + '-' + data[index].uptimeColor" style="float: left" class="mt-2" :color="data[index].uptimeColor" v-else>{{ data[index].uptime }}</vs-chip>
                            <vx-tooltip text="Old worker container version!" style="float: right" v-if="data[index].update_available && !data[index].disabled"><feather-icon style="color:#FF9F43" icon="AlertTriangleIcon" color="danger" class="cursor-pointer mt-2"/></vx-tooltip>

                        </vs-td>

                        <vs-td style="width: 165px">
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-eye" color="success" class="md:mb-0 mr-3 mb-1" @click="handleSelected(data[index])"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-play" color="success" class="md:mb-0 mr-1 mb-1" v-if="data[index].disabled" @click="startChannel(data[index].id)"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-refresh-cw" color="warning" class="md:mb-0 mr-1 mb-1" v-if="!data[index].disabled" @click="restartChannel(data[index].id)"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-square" color="danger" class="md:mb-0 mr-1 mb-1" v-if="!data[index].disabled" @click="disableChannel(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </div>
</template>
<script>

    export default {
        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                selectedChannels: [],

                channels: [],

                inputTemplates: [],
                workTemplates: [],
                outputTemplates: [],

                dataLoaded: false,

                updateDataTimer: '',
                updateUptimeTimer: '',
                currentTime: null
            }
        },
        methods: {
            handleSelected(tr) {
                this.$router.push('/worker_channel/' + tr.id)
            },
            loadData() {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                this.selectedChannels = []

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/')
                loadPromise.then(function(response) {
                    thisIns.channels = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const inputTemplatePromise = this.$http.get('/api/management/v1/template/?type=0')
                inputTemplatePromise.then(function(response) {
                    thisIns.inputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const workTemplatePromise = this.$http.get('/api/management/v1/template/?type=1')
                workTemplatePromise.then(function(response) {
                    thisIns.workTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const outputTemplatePromise = this.$http.get('/api/management/v1/template/?type=2')
                outputTemplatePromise.then(function(response) {
                    thisIns.outputTemplates = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, inputTemplatePromise, workTemplatePromise, outputTemplatePromise]).then(function() {
                    thisIns.currentTime = thisIns.moment()
                    thisIns.dataLoaded = true
                    thisIns.updateUptimeTimer = setInterval(() => { thisIns.currentTime = thisIns.moment() }, 1000)
                    thisIns.updateDataTimer = setInterval(() => { thisIns.updateData() }, 3000)
                }).finally(function() {
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            updateData() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/')
                loadPromise.then(function(response) {
                    if (JSON.stringify(thisIns.channels) !== JSON.stringify(response.data)) {
                        thisIns.channels = response.data
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            upstreamTypeToString(id) {
                switch (id) {
                case 0: return 'Source'
                case 1: return 'Worker'
                case 2: return 'Cluster'
                case 3: return 'Other'
                }
            },
            startChannel(id) {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + id + '/enable')
                reqPromise.then(function() {
                    thisIns.$printSuccess('Channel started')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            restartChannel(id) {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + id + '/restart')
                reqPromise.then(function() {
                    thisIns.$printSuccess('Channel restarted')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            disableChannel(id) {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + id + '/disable', {
                    end_time: this.moment().add(100, 'years')
                })
                reqPromise.then(function() {
                    thisIns.$printSuccess('Channel disabled')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            startSelected() {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const promiseArray = []
                const thisIns = this

                for (let x = 0; x < this.selectedChannels.length; x++) {
                    const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + this.selectedChannels[x] + '/enable', {
                        end_time: this.moment().add(100, 'years')
                    })
                    reqPromise.catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    promiseArray.push(reqPromise)
                }

                Promise.all(promiseArray).finally(function() {
                    thisIns.loadData()
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            restartSelected() {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const promiseArray = []
                const thisIns = this

                for (let x = 0; x < this.selectedChannels.length; x++) {
                    const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + this.selectedChannels[x] + '/restart', {
                        end_time: this.moment().add(100, 'years')
                    })
                    reqPromise.catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    promiseArray.push(reqPromise)
                }

                Promise.all(promiseArray).finally(function() {
                    thisIns.loadData()
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            disableSelected() {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const promiseArray = []
                const thisIns = this

                for (let x = 0; x < this.selectedChannels.length; x++) {
                    const reqPromise = this.$http.put('/api/management/v1/worker_channel/' + this.selectedChannels[x] + '/disable', {
                        end_time: this.moment().add(100, 'years')
                    })
                    reqPromise.catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })

                    promiseArray.push(reqPromise)
                }

                Promise.all(promiseArray).finally(function() {
                    thisIns.loadData()
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            },
            getChannelLink(id) {
                this.$vs.loading({
                    container: '#channelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.get('/api/management/v1/worker_channel/' + id + '/link')
                reqPromise.then(function(response) {
                    const newLink = response.data
                    thisIns.$copyText(response.data).then(function() {
                        thisIns.$printSuccess('Link copied to clipboard')
                    }, function() {
                        alert(newLink)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#channelDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                if (!this.dataLoaded) return []

                const data = []

                for (let x = 0; x < this.channels.length; x++) {
                    let uptimeText = ''
                    let uptimeColor = ''
                    let uptimeChip = false
                    let uptime = 0

                    if (this.channels[x].disabled) {
                        uptimeText = 'Disabled'
                        uptimeColor = '#9b59b6'
                        uptimeChip = true
                    } else {
                        if (this.channels[x].status === 1) {
                            uptime = this.moment.duration(this.currentTime.diff(this.moment(this.channels[x].last_session_start_time)))
                            uptimeText = ((uptime.days() > 0) ? (uptime.days() + 'd ') : '') + ('0' + uptime.hours()).slice(-2) + ':' + ('0' + uptime.minutes()).slice(-2) + ':' + ('0' + uptime.seconds()).slice(-2)
                        } else if (this.channels[x].status === 0) {
                            uptimeText = 'Offline'
                            uptimeColor = 'danger'
                            uptimeChip = true
                        } else if (this.channels[x].status === 2) {
                            uptimeText = 'Restarting'
                            uptimeColor = 'warning'
                            uptimeChip = true
                        } else {
                            uptimeText = 'Unknown'
                            uptimeColor = '#000000'
                            uptimeChip = true
                        }
                    }

                    data.push({
                        id: this.channels[x].id,
                        disabled: this.channels[x].disabled,
                        image_id: this.channels[x].image_id,
                        worker_name: this.channels[x].worker_name,
                        last_session_command: this.channels[x].last_session_command,
                        name: this.channels[x].name,
                        gpu: this.channels[x].gpu,
                        gpu_short: this.channels[x].gpu_short,
                        serialized_name: this.channels[x].serialized_name,
                        current_source_video_codec: this.channels[x].current_source_video_codec,
                        current_source_dimensions: this.channels[x].current_source_dimensions,
                        current_source_audio_codec: this.channels[x].current_source_audio_codec,
                        current_source_provider: this.channels[x].current_source_provider,
                        status: this.channels[x].status,
                        output_type: this.channels[x].output_type,
                        update_available: this.channels[x].update_available,
                        current_version_date: this.channels[x].current_version_date,
                        latest_version_date: this.channels[x].latest_version_date,
                        upstream_type: this.upstreamTypeToString(this.channels[x].upstream_type),
                        in_template: (this.channels[x].in_template.id === 0) ? 'Default' : this.inputTemplateMap[this.channels[x].in_template.id].name,
                        work_template: (this.channels[x].work_template.id === 0) ? 'Default' : this.workTemplateMap[this.channels[x].work_template.id].name,
                        out_template: (this.channels[x].out_template.id === 0) ? 'Default' : this.outputTemplateMap[this.channels[x].out_template.id].name,
                        uptime: uptimeText,
                        uptimeNum: uptime,
                        uptimeColor: uptimeColor,
                        uptimeChip: uptimeChip
                    })
                }

                return data
            },
            inputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.inputTemplates.length; i++) {
                    templatesMap[this.inputTemplates[i].id] = this.inputTemplates[i]
                }

                return templatesMap
            },
            workTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.workTemplates.length; i++) {
                    templatesMap[this.workTemplates[i].id] = this.workTemplates[i]
                }

                return templatesMap
            },
            outputTemplateMap() {
                const templatesMap = {}
                for (let i = 0; i < this.outputTemplates.length; i++) {
                    templatesMap[this.outputTemplates[i].id] = this.outputTemplates[i]
                }

                return templatesMap
            },
            allSelected: {
                get() {
                    if (this.channels.length === 0) return false

                    for (let x = 0; x < this.channels.length; x++) {
                        if (!this.selectedChannels.includes(this.channels[x].id)) return false
                    }

                    return true
                },
                set() {
                    if (this.allSelected) {
                        this.selectedChannels = []
                        return
                    }

                    for (let x = 0; x < this.channels.length; x++) {
                        if (!this.selectedChannels.includes(this.channels[x].id)) {
                            this.selectedChannels.push(this.channels[x].id)
                        }
                    }
                }
            },
            someSelected: {
                get() {
                    return this.channels.length > this.selectedChannels.length && this.selectedChannels.length > 0
                },
                set() {
                    for (let x = 0; x < this.channels.length; x++) {
                        if (!this.selectedChannels.includes(this.channels[x].id)) {
                            this.selectedChannels.push(this.channels[x].id)
                        }
                    }
                }
            }
        },
        beforeDestroy() {
            clearInterval(this.updateUptimeTimer)
            clearInterval(this.updateDataTimer)
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
